<script>
  import About from "./About.svelte";

  let about;
</script>

<header class="header">
  <div class="title">電卓育成シミュレーター</div>
  <div class="about">
    <button
      class="button"
      on:click={() => {
        about.viewAbout();
      }}
      >About
    </button>
  </div>
</header>
<About bind:this={about} />

<style lang="scss">
  $height: 48px;

  .header {
    width: 100%;
    height: $height;
    box-shadow: 0 3px 1px -1px rgba(0, 0, 0, 0.25);
    padding: 0;
    display: flex;
    justify-content: space-between;
    background-color: #4169e1;

    .title {
      color: white;
      padding-left: 10px;
      line-height: $height;
      font-weight: bold;
      font-size: 1.1rem;
    }
    .about {
      padding-right: 10px;
      line-height: $height;
    }
  }
</style>
